export const CUSTOM_SCROLLBAR_STYLES = {
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
};

export const COLUMNS_DATA = [
  {id: 'stopName', label: 'Stop Name', minWidth: 100},
  {id: 'status', label: 'Status', minWidth: 100},
  {id: 'booking', label: 'Booking', minWidth: 100},
  {id: 'supplierBookingId', label: 'Supplier Booking Id', minWidth: 100},
  {id: 'displayName', label: 'Room Name', minWidth: 100},
  {id: 'providerAmount', label: 'Provider Amount', minWidth: 100},
  {id: 'finalAmount', label: 'Final Amount', minWidth: 100},
  {id: 'discountAmount', label: 'Discount Amount', minWidth: 100},
  {id: 'beforeDiscountAmount', label: 'Pre-Discount Amount', minWidth: 100},
  {id: 'taxAmount', label: 'Tax Amount', minWidth: 100},
  {id: 'profitAmount', label: 'Profit Amount', minWidth: 100},
  {id: 'checkIn', label: 'Checkin', minWidth: 100},
  {id: 'checkOut', label: 'Checkout', minWidth: 100},
  {id: 'cancellationDate', label: 'Cancellation Upto', minWidth: 100},
];

export const COLUMNS_HEADERS = [
  {id: 'name', key: 'name', label: 'Name'},
  {
    id: 'internalBookingId',
    key: 'internalBookingId',
    label: 'Internal Booking Id',
  },
  {id: 'status', key: 'status', label: 'Status'},
  {id: 'productName', key: 'productName', label: 'Product'},
  {id: 'providerAmount', key: 'providerAmount', label: 'Provider Amount'},
  {id: 'profitAmount', key: 'profitAmount', label: 'Profit Amount'},
  {id: 'discountAmount', key: 'discountAmount', label: 'Discount Amount'},
  {id: 'finalAmount', key: 'finalAmount', label: 'Final Amount'},
  {id: 'taxAmount', key: 'taxAmount', label: 'Tax Amount'},
];

export const RECORDS_PER_PAGE = 10;

export const BOOKING_STATUSES = {
  pending: {label: 'Pending', value: 'pending'},
  failed: {label: 'Failed', value: 'failed'},
  completed: {label: 'Completed', value: 'completed'},
  resolved: {label: 'Resolved', value: 'resolved'},
};

export const PRODUCT_STATUSES = {
  draft: {label: 'Draft', value: 'draft'},
  published: {label: 'Published', value: 'published'},
};

export const BOOKING_TYPES = {
  stay: {
    value: 'stay',
    subTypes: ['city', 'region'],
    providers: {
      rateHawk: {
        value: 'ratehawk',
      },
    },
  },
  transport: {
    value: 'transport',
    subTypes: ['ferry'],
    providers: {
      directFerries: {
        value: 'directFerries',
      },
    },
  },
};
